<template>
    <GlassSurface
        as="aside"
        :background="GlassSurfaceBackgrounds.Secondary"
        class="sidebar h-full w-full flex flex-col overflow-hidden py-6 z-50 rounded-r-(--border-radius-xl) rounded-l-0 max-md:bg-none! max-md:bg-(--sidebar-background) md:rounded-(--border-radius-xl)">
        <SidebarHeader />
        <SidebarNavigation />
        <SidebarUserProfile />
    </GlassSurface>
</template>

<script setup lang="ts">
    import { GlassSurfaceBackgrounds } from '@/assets/css/themes/custom-components/constants/glass-surface';
</script>
